export const uploadImage = async (
  file: File,
  options?: Partial<{ preset: string; maxUploadSize: number }>,
) => {
  const { preset = 'xiammksy' } = options || {};
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', preset);
  if (file.size > options.maxUploadSize << 10)
    return Promise.reject('Max size');
  const response = await fetch(
    'https://api.cloudinary.com/v1_1/zignaly/image/upload',
    {
      method: 'POST',
      body: formData,
    },
  );
  return response.json();
};
